enum QuestionType {
  ShortText = "short-text",
  LongText = "long-text",
  Radio = "radio",
  Checkbox = "checkbox",
}

export default QuestionType;
